module.exports = __webpack_public_path__ + "img/divisonBot.1bd03981.png";